import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { change as changeFormValue, formValueSelector } from 'redux-form';
import { constants } from '@eti/utils';
import { getPrice, hasSeatSelection } from '../utils/selection';
const EMPTY_SEAT_MAP = {};
const EMPTY_DECK_SELECTIONS = {};
const useSeatMapForm = ({
  form,
  onConfirm,
  onDismiss,
  shouldRenderInline,
  travelers
}) => {
  const dispatch = useDispatch();
  const [isSummaryShowing, setIsSummaryShowing] = useState(false);
  const {
    price,
    markup
  } = useSelector(state => getPrice('seatMap', form)(state), shallowEqual);
  const selectedSeats = useSelector(state => {
    const seatMapValue = formValueSelector(form)(state, 'seatMap') || EMPTY_SEAT_MAP;
    const seatsBySegment = {
      ...seatMapValue
    };
    delete seatsBySegment.value;
    delete seatsBySegment.activeDecks;
    return seatsBySegment;
  }, shallowEqual);
  const shouldShowConfirmationModal = form === 'traveler-details';
  const isSeatSelected = hasSeatSelection(selectedSeats);
  useEffect(() => {
    if (!isSummaryShowing) {
      return;
    }
    dispatch(changeFormValue(form, 'seatMap.value.value', isSeatSelected ? 'true' : 'false'));
  }, [dispatch, form, isSummaryShowing, isSeatSelected]);
  const deckSelectionsBySegment = useSelector(state => formValueSelector(form)(state, 'seatMap.activeDecks') || EMPTY_DECK_SELECTIONS);
  const onDeckSelectionChange = (boundSegmentIndex, option) => {
    var _deckSelectionsBySegm;
    if (((_deckSelectionsBySegm = deckSelectionsBySegment[boundSegmentIndex]) === null || _deckSelectionsBySegm === void 0 ? void 0 : _deckSelectionsBySegm.value) === option.value) {
      return;
    }
    const updatedDeckSelections = {
      ...deckSelectionsBySegment,
      [boundSegmentIndex]: option
    };
    dispatch(changeFormValue(form, 'seatMap.activeDecks', updatedDeckSelections));
  };
  const getSelected = useCallback(activeSegment => {
    const segmentData = selectedSeats[activeSegment];
    if (!segmentData || typeof segmentData !== 'object') {
      return [];
    }
    return Object.values(segmentData).filter(value => value !== null);
  }, [selectedSeats]);
  const onChange = (boundSegmentIndex, travelerId, carrier, column, row, seat, seatPrice, seatMarkup, deckType) => {
    const traveler = travelers.find(t => t.id === travelerId);
    dispatch(changeFormValue(form, 'seatMap.value.value', 'true'));
    dispatch(changeFormValue(form, `seatMap.${boundSegmentIndex}.traveler${travelerId}`, {
      ...traveler,
      carrier,
      column,
      price: seatPrice,
      row,
      value: seat,
      markup: seatMarkup,
      id: travelerId,
      deckType,
      seatPreference: null
    }));
  };
  const onChangeSeatingLightBeside = ({
    boundSegmentIndex,
    carrier,
    price: lightBesidePrice,
    markup: lightBesideMarkup,
    seatPreference
  }) => {
    var _travelers$filter;
    const nonInfantTravelers = (_travelers$filter = travelers === null || travelers === void 0 ? void 0 : travelers.filter(t => t.ageType !== constants.ageTypes.INFANT)) !== null && _travelers$filter !== void 0 ? _travelers$filter : [];
    const travelerCount = nonInfantTravelers.length || 1;
    const segmentTravelers = nonInfantTravelers.reduce((acc, traveler) => ({
      ...acc,
      [`traveler${traveler.id}`]: {
        ...traveler,
        carrier,
        price: lightBesidePrice / travelerCount,
        markup: lightBesideMarkup / travelerCount,
        seatPreference
      }
    }), {});
    dispatch(changeFormValue(form, 'seatMap.value.value', 'true'));
    dispatch(changeFormValue(form, `seatMap.${boundSegmentIndex}`, segmentTravelers));
  };
  const onClose = seatSelection => {
    if (!hasSeatSelection(seatSelection)) {
      dispatch(changeFormValue(form, 'seatMap.value.value', 'false'));
    }
    onDismiss === null || onDismiss === void 0 || onDismiss();
  };
  const onRemove = (boundSegmentIndex, travelerId) => {
    const key = travelerId === undefined ? `seatMap.${boundSegmentIndex}` : `seatMap.${boundSegmentIndex}.traveler${travelerId}`;
    dispatch(changeFormValue(form, key, null));
  };
  const onOptOut = () => {
    dispatch(changeFormValue(form, 'seatMap.value.value', 'false'));
    onDismiss === null || onDismiss === void 0 || onDismiss();
  };
  const onSeatConfirmation = seatSelection => {
    if (!hasSeatSelection(seatSelection)) {
      dispatch(changeFormValue(form, 'seatMap.value.value', 'false'));
    }
    onConfirm === null || onConfirm === void 0 || onConfirm();
  };
  return {
    deckSelectionsBySegment,
    getSelected,
    isSummaryShowing,
    onChange,
    onChangeSeatingLightBeside,
    onClose,
    onDeckSelectionChange,
    onOptOut,
    onRemove,
    onSeatConfirmation,
    selectedSeats,
    setIsSummaryShowing,
    shouldRenderInline,
    shouldShowConfirmationModal,
    totalMarkup: markup,
    totalPrice: price
  };
};
export default useSeatMapForm;
//# sourceMappingURL=useSeatMapForm.js.map